import { Link } from "react-router-dom";
import '../../style/components/navbar.css';
import { useContext, useEffect } from "react";
import { config } from "../../context/config";
import { auth } from "../../context/auth";
import { action } from '../../context/action';
import { switchh } from "../../context/switch";
import { recodeNow } from "../indexDB/indexDBStora";
import { useTransaction } from "../../funcs/hooks/usetransaction";
import { useTranslation } from "react-i18next";

export default function NavBar() {
    const { t } = useTranslation();
    const {setStylingNav, stylingNav, setPage} = useContext(config);
    const { setErrorMessage, setEditMode, setSuccessMessage } = useContext(action);
    const { setLoadingProcess } = useContext(switchh);
    const { ActivEmp } = useContext(auth);

    const logout_transaction = useTransaction("logout");

    const LogOut = async () => {
        if(!logout_transaction.decision.status) {
            alert(logout_transaction.decision.message);
        }
        else {
            await recodeNow(logout_transaction.data , "transactions");
        }
    
        document.cookie = "session_emp=; Max-Age=0; path=/";
        window.location.href = "/";
    }

    useEffect(() => {
        const grow_nav = document.getElementById("btn-grow-nav") || ""
        if(grow_nav !== ""){
            grow_nav.addEventListener("click", 
                () => {
                    setStylingNav(true)
                }
            )
        }
        const shrink_nav = document.getElementById("hover").addEventListener("mouseleave", () => {
            const timout =  setTimeout(() => { setStylingNav(false) }, 5000)
            return () => clearTimeout(timout)
        })
    }, [stylingNav])

    const Reset = () => {
        setErrorMessage("");
        setSuccessMessage("");
        setLoadingProcess(false);
        setEditMode(false)
        setPage(1);
    }
    return (
        <div id="hover" className={`nav ${stylingNav ? "growNav" : ""}`}>
            <div className="container">
                <ul onClick={() => Reset()} className="sections-links">
                    {!stylingNav && <li id="btn-grow-nav" onClick={() => setStylingNav(true)}><button type="button"><img src={require("../../docs/light/navbar.png")}  alt="2"/></button></li>}
                    {ActivEmp.role === "cashier" || ActivEmp.role === "delivery" ? 
                    <>
                        <li title="POS"><Link to={'/pos'}> <img src={require("../../docs/light/point-of-sale.png")}  alt="2"/> <span>{t("sections:POS.full")}</span></Link></li>
                        {
                        ActivEmp.role === "delivery" && 
                        <li title="monitor delivery"><Link to={'/mnbike'}> <img src={require("../../docs/light/bike.png")}  alt="2"/> <span>{t("sections:followUpPilots")}</span></Link></li>}
                    </>
                    :
                    <>
                        <li title="dashboard"><Link to={'/'}> <img src={require("../../docs/light/dashboard.png")}  alt="2"/> <span>{t("sections:dashboard")}</span></Link></li>
                        <li title="employees"><Link to={'/employees'}> <img src={require("../../docs/light/user.png")}  alt="2"/> <span>{t("sections:HR.full")}</span></Link></li>
                        <li title="category"><Link to={'/categories'}> <img src={require("../../docs/light/tag.png")}  alt="2"/> <span>{t("sections:category.full")}</span></Link></li>
                        <li title="products"><Link to={'/products'}> <img src={require("../../docs/light/box.png")}  alt="2"/> <span>{t("sections:products.full")}</span></Link></li>
                        <li title="Wholesalers"><Link to={'/supplier'}> <img src={require("../../docs/light/supplier.png")}  alt="2"/> <span>{t("sections:suppliers.full")}</span></Link></li>
                        <li title="warehouse"><Link to={'/investory'}> <img src={require("../../docs/light/warehouse.png")}  alt="2"/> <span>{t("sections:investory.full")}</span></Link></li>
                        <li title="sales"><Link to={'/sales'}> <img src={require("../../docs/light/growth.png")}  alt="2"/> <span>{t("sections:sales.full")}</span></Link></li>
                        <li title="settings"><Link to={'/settings'}> <img src={require("../../docs/light/settings.png")} alt="2" /> <span>{t("sections:settings")}</span></Link></li>
                        {/* <li title="orders"><Link to={'/'}> <img src={require("../../docs/light/shopping-cart.png")}  alt="2"/> <span>الطلبات</span></Link></li> */}
                    </>
                    }
                </ul>
                <ul className="sections-links">
                    <li title="mode"><Link to={'/'}> <img src={require("../../docs/light/night-mode.png")}  alt="2"/> <span>{t("sections:mode")}</span></Link></li>
                    <li title="help"><Link to={'/'}> <img src={require("../../docs/light/help_button.png")}  alt="2"/> <span>{t("sections:help")}</span></Link></li>
                    <li title="support"><Link to={'/'}> <img src={require("../../docs/light/costumer-service.png")} alt="2" /> <span>{t("sections:technicalSupport")}</span></Link></li>
                    <li title="logout"><button onClick={() => LogOut()}> <img src={require("../../docs/light/logout.png")}  alt="2"/> <span>{t("sections:logout")}</span></button></li>
                </ul>
            </div>

        </div>
    )
}